import { render, staticRenderFns } from "./NewSignupContinue.vue?vue&type=template&id=07f9953f&scoped=true"
import script from "./NewSignupContinue.vue?vue&type=script&lang=js"
export * from "./NewSignupContinue.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/authen.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/newLogin.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./NewSignupContinue.vue?vue&type=style&index=2&id=07f9953f&prod&lang=css"
import style3 from "./NewSignupContinue.vue?vue&type=style&index=3&id=07f9953f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f9953f",
  null
  
)

export default component.exports